import { useEffect, useState } from 'react';
import { Space } from 'antd';
import { observer } from 'mobx-react-lite';

import { useResource } from 'app/common/api';
import { DataStore } from 'app/common/data-storage/features/data-storage';
import {
  NotificationsRender,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { TRole } from 'app/railways/domains/access/core/role';
import { useAuthStatusWriter } from 'app/railways/domains/auth/features/auth-status';

import { SelectRoles } from '../../../../../railways/domains/access/ui/select-roles';
import { Loading } from '../../../../../ui';
import { getEmployeeRolesRequest } from '../../requests';

export const EmployeeRoleList = observer(({ onChange, selected }: any) => {
  const [rolesStore] = useState(() => new DataStore<TRole[]>([]));
  const authStatus = useAuthStatusWriter();
  const notify = useNotifyFactory();
  const rolesResource = useResource<void, TRole[]>({
    request: getEmployeeRolesRequest,
    errorNotify: notify,
    onAuthRequired: () => authStatus.denyAccess(),
    onDone(roles) {
      rolesStore.setData(roles);
      console.log(roles);
    },
  });

  const isLoading = rolesResource.isLoading;

  useEffect(() => {
    rolesResource.send();
  }, []);

  return (
    <Loading active={isLoading}>
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <NotificationsRender notifyStore={notify} />

        <div style={{ overflow: 'auto' }}>
          <SelectRoles
            roles={rolesStore.data}
            selected={selected}
            onChange={onChange}
          />
        </div>
      </Space>
    </Loading>
  );
});
